import React, { FC } from 'react';
import { Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAllTerminals } from '~/hooks/terminals';

interface TerminalInputProps {
  value?: any;
  disabled?: boolean;
  mPOSOnly?: boolean;
  [x: string]: any;
}

const TerminalInput: FC<TerminalInputProps> = (props) => {
  const { value, disabled, mPOSOnly } = props;
  const [t] = useTranslation('terminals');
  const { data, isLoading } = useAllTerminals();
  const options: { value: string; label: any }[] | undefined = data
    ?.filter((item) => (mPOSOnly ? item?.terminalType === 'MPOS' : true))
    ?.map((item) => ({
      value: item.id as string,
      label: item.label,
    }));
  if (value && !data?.find((item) => item.id === value)) {
    options?.unshift({
      value,
      label: <Typography.Text type="danger">{t('deletedTerminal')}</Typography.Text>,
    });
  }

  return (
    <Select
      options={options}
      filterOption={(inputValue, option) =>
        (option?.label as string)?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
      }
      showSearch
      disabled={isLoading || disabled}
      allowClear
      style={minWidth}
      {...props}
    />
  );
};

const minWidth = { minWidth: 130 };

export default TerminalInput;
